import { render } from "./cardButton.vue?vue&type=template&id=2f0fe1de"
import script from "./cardButton.vue?vue&type=script&lang=js"
export * from "./cardButton.vue?vue&type=script&lang=js"

import "./cardButton.vue?vue&type=style&index=0&id=2f0fe1de&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__